{
  "title": "Komponentenversion",
  "technicalVersion": "Technische Version:",
  "components": {
    "alertManager": "Warnungsmanager",
    "deviceTwinManagerEsoft": "Gerätezwillings-Manager (eSoftLink)",
    "campaignManager": "Kampagnen-Manager",
    "pkiConnector": "PKI-Konnektor",
    "userManager": "Benutzermanager",
    "applicationManager": "Anwendungsmanager",
    "contentManager": "Inhaltsmanager",
    "caCertificateManager": "Zertifizierungsstellen-Manager",
    "certificateManager": "Zertifikatsmanager",
    "apiGateway": "API-Gateway",
    "translationManager": "Übersetzungsmanager",
    "operationManager": "Betriebsmanager",
    "deviceTwinManager": "Gerätezwillings-Manager",
    "licenseManager": "Lizenzmanager",
    "dataManager": "Datenmanager",
    "as": "Front-Anwendungsservice",
    "fi": "Front-Schnittstelle",
    "lwm2mConnector": "LwM2M-Konnektor",
    "dataEnrichment": "Datenanreicherung"
  },
  "tile": {
    "version": "Version",
    "noData": "Die Version dieser Komponente konnte nicht abgerufen werden.",
    "component": "Komponente"
  }
}
